/* iceberg-ui */
import { Flex, Flyout } from '@auviknetworks/iceberg-ui';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';

/* Internal Components */
import { useManagedTableV2Context } from '../ManagedTableV2ContextProvider';
import { CustomTableContext, ShowFlyoutMenuActionEnum } from '../types';
import { DeleteTableView } from './internal/DeleteTableView';
import { SaveEditTableView } from './internal/SaveEditTableView';

const ActionComponent = ({ action }: { action: ShowFlyoutMenuActionEnum }) => {
    switch (action) {
        case 'edit':
        case 'saveAsNewView':
            return <SaveEditTableView />;
        case 'delete':
            return <DeleteTableView />;
        default:
            return null;
    }
};

export const TableFlyout = <T,>({
    'data-testid': dataTestId = 'tableFlyout'
}: {
    /**
     * The data test id for this table flyout component.
     */
    'data-testid'?: string;
}) => {
    const { t } = useTranslation();

    const { showFlyoutMenu, setShowFlyoutMenu } =
        useManagedTableV2Context<T>() as CustomTableContext<T>;

    return (
        <Flyout
            data-testid={dataTestId}
            title={t(`TableViews.flyout.title.${showFlyoutMenu}`)}
            onClose={() => setShowFlyoutMenu(ShowFlyoutMenuActionEnum.hide)}
        >
            {/* 75px is the height of the flyout header */}
            <Flex height="calc(100vh - 75px);" width="640px">
                <ActionComponent action={showFlyoutMenu} />
            </Flex>
        </Flyout>
    );
};
